import { LoadingCard } from '@components/utils/LoadingCard'
import { UserDevicesResult } from '@models/PostHog'
import { useTenant } from '@modules/tenant/contexts/tenant/TenantContext'
import { fetchDevicesForUser } from '@services/UserService'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Card, Empty, Space, Tag, Typography } from 'antd'
import { FC, useEffect, useState } from 'react'
import { InnerUserDeviceAnonymousId } from './InnerUserDeviceAnonymousId'

const { Text } = Typography

interface Props {
  userId: number
  whatsappPhoneId: string | undefined
}

const DeviceList: FC<Props> = ({ userId, whatsappPhoneId }) => {
  const { allPlatforms } = useTenant()
  const [data, setData] = useState<UserDevicesResult>({
    trashed: [],
    devices: [],
  })
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    setIsLoading(true)
    fetchDevicesForUser(userId)
      .then((result) => {
        setData(result)
      })
      .finally(() => setIsLoading(false))
  }, [])

  return (
    <Space orientation="vertical" className="w-full" size={8}>
      <PageTitle level={5} title={'Devices'} style={{ margin: 0 }} />
      {isLoading && <LoadingCard />}
      {!isLoading && (
        <Space orientation="vertical" className="w-full">
          {!whatsappPhoneId &&
            (!data ||
              (data &&
                data?.devices.length == 0 &&
                data?.trashed.length == 0 && (
                  <Card>
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={'No device registered'}
                    />
                  </Card>
                )))}
          {whatsappPhoneId && (
            <Card>
              <Space className="w-full space-between">
                <Space size={4}>
                  {allPlatforms.whatsapp.icon}
                  <Text>{allPlatforms.whatsapp.name}</Text>
                </Space>
                <Space>
                  <Tag color="green">{whatsappPhoneId}</Tag>
                </Space>
              </Space>
            </Card>
          )}
          {data?.devices.map((device, index) => (
            <InnerUserDeviceAnonymousId
              userId={userId}
              key={`device-${index}`}
              device={device}
            />
          ))}
          {data?.trashed.map((device, index) => (
            <InnerUserDeviceAnonymousId
              userId={userId}
              key={`trashed-${index}`}
              device={device}
              trashed
            />
          ))}
        </Space>
      )}
    </Space>
  )
}

type DeviceListType = { DeviceList: typeof DeviceList }

export { DeviceList, type DeviceListType }
